import React from 'react';
import './StatCard.css';

const StatCard = ({ label, value, subValue, icon, index = 0 }) => (
  <div className="stat-card lift-card notched-card stagger-in" style={{ '--i': index }}>
    <div className="stat-icon">{icon}</div>
    <div className="stat-content">
      <span className="stat-value hero-numeral">{value}</span>
      {subValue && <span className="stat-subvalue">{subValue}</span>}
      <span className="stat-label">{label}</span>
    </div>
  </div>
);

export default StatCard;
